<template>
  <div>
    <headline>{{ $t('login-history.title') }}</headline>
    <login-history-table :load="load" with-channel/>
  </div>
</template>

<script>
import LoginHistoryTable from "@elements/LoginHistoryTable.vue";
import CustomerRepository from "@repository/CustomerRepository";

/**
 * L'onglet Connexion d'un client : ses tentatives de connexion (application, espace client, SSO), réussies ou non.
 * Réservé aux développeurs (permission LOGIN_HISTORY_VIEW) pour l'instant.
 */
export default {
  components: {LoginHistoryTable},

  computed: {
    load() {
      const customerId = this.$route.params.id
      return (page, limit) => CustomerRepository.loginAttempts(customerId, {page, limit})
    },
  },
}
</script>
